const paymentStyle = {
  mainBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "start",
    width: "83%",
    textAlign: "center",
    margin: "auto",
    borderRadius: "5px",
    "@media (max-width: 1024px)": {
      width: "80%",
    },
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  textFont: {
    fontSize: "14px",
    fontFamily: "Noto Sans",
  },
  fieldSec: {
    display: "flex",
    width: "100%",
    marginBottom: "1rem",
    justifyContent: "flex-start",
    "@media (max-width: 1024px)": {
      alignItems: "center",
    },
    "@media (max-width: 768px)": {
      marginBottom: "0.5rem",
    },
  },
  fieldLabel: {
    display: "flex",
    alignItems: "center",
    fontSize: "1rem",
    marginLeft: "2rem",
    fontFamily: "Noto Sans",
    "@media (max-width: 1024px)": {
      fontSize: "0.9rem",
      textAlign: "center",
      justifyContent: "flex-start",
      marginBottom: "0.5rem",
    },
    "@media (max-width: 768px)": {
      fontSize: "0.8rem",
      textAlign: "center",
      justifyContent: "flex-start",
      marginLeft: "0",
    },
  },
  paySection: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    "@media (max-width: 1024px)": {
      flexDirection: "column",
    },
  },
  amountValue: {
    display: "flex",
    marginLeft: "2rem",
    marginRight: "2rem",
    "@media (max-width: 1024px)": {
      marginRight: "0",
    },
  },
  textAmountSection: {
    display: "inline-flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-start",
    // margin: "1rem",
    "@media (max-width: 1024px)": {
      alignItems: "center",
      margin: "1rem 0",
    },
  },
  amountLabel: {
    // marginLeft: "5rem",
    "@media (max-width: 1024px)": {
      // marginLeft: "3rem",
    },
    "@media (max-width:768px)": {
      // marginLeft: "3rem",
    },
  },
  amountLabelBox: {
    marginRight: "2.5rem",
    "@media (max-width: 1024px)": {
      marginRight: "3rem",
    },
  },
  amountAmtBox: {
    marginLeft: "1rem",
    "@media (max-width: 1024px)": {
      marginLeft: "0",
      textAlign: "center",
    },
  },
  amt: {
    wordWrap: "break-word",
    fontWeight: "bold",
    textAlign: "left",
    fontFamily: "Noto Sans",
    "@media (max-width: 1024px)": {
      textAlign: "center",
    },
  },
  btnBox: {
    marginTop: "1rem",
    marginBottom: "1rem",
    marginLeft: "1.5rem",
  },
  payBtn: {
    width: "300px",
    textTransform: "none",
    padding: "6px 16px",
    borderRadius: "50px",
    color: "#ffffff",
  },
  pSuccesMain: {
    width: "100%",
    height: "88vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  pSuccessMai2: {
    padding: "2rem",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    fontFamily: "Noto Sans",
    boxShadow: "0px 6px 10px 0px rgba(63, 63, 63)",
    borderRadius: "5px",
  },
  pSuccessMsgSec: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px",
  },
  pSuccessIcon: {
    color: "green",
    "@media (max-width:768px)": {
      fontSize: "1.5rem",
    },
  },
  pSuccessMsg: {
    textAlign: "center",
    fontSize: "1.5rem",
    color: "green",
    wordWrap: "break-word",
    "@media (max-width:768px)": {
      fontSize: "1rem",
    },
  },
  pSuccessSecBox: {
    width: "100%",
    display: "inline-flex",
  },
  pFailIcon: {
    color: "red",
  },
  pFailMsg: {
    fontSize: "1.5rem",
    color: "red",
    wordWrap: "break-word",
  },
  transactionId: {
    wordWrap: "break-word",
    fontSize: "14px",
  },
  payNowImagesStyles: {
    width: "100%",
    height: "100px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    cursor: "pointer",
    padding: 2,
    "&:hover": {
      backgroundColor: "#f9f9f9",
    },
  },
  shadowContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "100%",
    padding: "0.5rem",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
  },
  title: {
    lineHeight: "24px",
    textAlign: "left",
    marginBottom: "1rem",
    fontFamily: "Noto Sans",
  },
  innerContainerStyle: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    padding: "10px",
    borderRadius: "8px",
  },
  gatewayTitle: {
    fontSize: "1.2rem",
    fontFamily: "Noto Sans",
    "@media (max-width:768px)": {
      display: "none",
    },
  },
  gatewayContainer: {
    display: "flex",
    gap: "1rem",
    flexDirection: "column",
  },
  mainContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    // background: "#f7f9fb",
    minHeight: "100vh",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    position: "relative",
    overflow: "visible", // Let natural page scrolling handle it
    fontFamily: "Noto Sans",
  },
  card: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    background: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    padding: "1.5rem",
    marginBottom: "1.5rem",
    width: "100%",
    maxWidth: 420,
    position: "relative",
    transform: "translateZ(0)", // Force hardware acceleration
    fontFamily: "Noto Sans",
  },
  paymentInfoTitle: {
    fontWeight: 600,
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
    fontSize: "1.1rem",
    fontFamily: "Noto Sans",
  },
  paymentInfoRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
  },
  paymentInfoLabel: {
    color: "#888",
    fontFamily: "Noto Sans",
  },
  paymentInfoValue: {
    fontWeight: 600,
    fontFamily: "Noto Sans",
  },
  paymentInfoAmount: {
    color: "#20a7db",
    fontWeight: 700,
    fontSize: "1.5rem",
    fontFamily: "Noto Sans",
  },
  gatewayCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "12px",
    background: "#fff",
    cursor: "pointer",
    transition: "border 0.2s, box-shadow 0.2s",
    fontFamily: "Noto Sans",
  },
  gatewayCardSelected: {
    border: "2px solid #20a7db",
    boxShadow: "0 0 0 2px #20a7db",
  },
  gatewayCardDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    background: "#fafafa",
  },
  gatewayCardLeft: {
    display: "flex",
    alignItems: "center",
  },
  gatewayLogo: {
    width: 40,
    height: 40,
    marginRight: 16,
    objectFit: "contain",
    borderRadius: "4px",
    background: "#fff",
  },
  gatewayLabel: {
    fontWeight: 500,
    textTransform: "capitalize",
    fontSize: "1rem",
    fontFamily: "Noto Sans",
  },
  chip: {
    marginLeft: "8px",
  },
  unavailableLogo: {
    width: 40,
    height: 40,
    background: "#eee",
    borderRadius: "50%",
    marginRight: 16,
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: "0.5rem",
    fontSize: "1rem",
    color: "#888",
    fontFamily: "Noto Sans",
  },
  unavailableGatewaysContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "relative",
    transform: "translateZ(0)", // Force hardware acceleration
  },
  actionContainer: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    transform: "translateZ(0)", // Force hardware acceleration
    paddingBottom: "2rem", // Add bottom padding for scrolling
  },
  payButton: {
    width: "100%",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "1.1rem",
    borderRadius: "8px",
    padding: "9px 0",
    background: "#20a7db",
    color: "#fff",
    boxShadow: "0 2px 8px rgba(79,140,255,0.08)",
    marginBottom: "16px",
    "&:hover": { background: "#20a7db" },
    fontFamily: "Noto Sans",
  },
  securityFooter: {
    textAlign: "center",
    color: "#888",
    fontSize: "0.85rem",
    //marginTop: "16px",
    margin:"8px",
    fontFamily: "Noto Sans",
  },
  securityFooterIcon: {
    marginBottom: "4px",
    fontFamily: "Noto Sans",
  },
  paymentDetailsContainer: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    padding: "1rem",
    fontFamily: "Noto Sans",
  },
};

export default paymentStyle;
